import { useState } from 'react';
import {BsFillArrowLeftSquareFill, BsFillArrowRightSquareFill} from 'react-icons/bs';

const ImageSlider = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Sort images based on the SortOrder field
    const sortedImages = [...images].sort((a, b) => a.SortOrder - b.SortOrder);
  
    const goPrev = () => setCurrentIndex((prev) => (prev - 1 + sortedImages.length) % sortedImages.length);
    const goNext = () => setCurrentIndex((prev) => (prev + 1) % sortedImages.length);
  
    return (
        <div className="image-slider">
          <div className="image-container">
            <img src={sortedImages[currentIndex]?.PhotoUrl} alt={`image-${currentIndex}`} />
          </div>
          
          <div className="arrow-container">
              <BsFillArrowLeftSquareFill onClick={goPrev} className="arrow-button" />
              <BsFillArrowRightSquareFill onClick={goNext} className="arrow-button" />
          </div>
        </div>
    );
};

export default ImageSlider;